import React, { FC } from "react";
import { Table } from "semantic-ui-react";

interface IProps {
    index: number,
    action: any
}

const DraggableTableTow: FC<IProps> = (props) => {


    const onDragStart = (e: any, i: number) => {
        e.dataTransfer.setData("index", i);
    }

    const onDragOver = (e: any) => {
        e.preventDefault();
    }

    const onDrop = (ev: any, a: any) => {
        let b = ev.dataTransfer.getData("index");
        props.action(parseInt(a, 10), parseInt(b, 10));
    };

    return (
        <Table.Row
            draggable
            className="draggable-table-row"
            onDragStart={(e: any) => { onDragStart(e, props.index) }}
            onDragOver={(e: any) => { onDragOver(e) }}
            onDrop={(e: any) => { onDrop(e, props.index) }}
        >
            {props.children}
        </Table.Row>
    );
}

export default DraggableTableTow;